export const FormHeading = ({ className, children }) => (
  <h3 className={`mb-2 font-bold text-2xl ${className}`}>{children}</h3>
)
